import {
  TIPO_GESTION_CONTACTO_LIST,
  TIPO_GESTION_CONTACTO_LIST_CHANGE,
  TIPO_GESTION_CONTACTO_LIST_SUCCESS,
  TIPO_GESTION_CONTACTO_LIST_FAILED,
  TIPO_GESTION_CONTACTO_LISTA,
  TIPO_GESTION_CONTACTO_LISTA_SUCCESS,
  TIPO_GESTION_CONTACTO_LISTA_FAILED,
  TIPO_GESTION_CONTACTO_ADD,
  TIPO_GESTION_CONTACTO_ADD_SUCCESS,
  TIPO_GESTION_CONTACTO_ADD_FAILED,
  TIPO_GESTION_CONTACTO_DELETE,
  TIPO_GESTION_CONTACTO_DELETE_SUCCESS,
  TIPO_GESTION_CONTACTO_DELETE_FAILED,
} from "./actionTypes";

const initialState = {
  tipoGestionContacto: [],
  tipoGestionContactoAdded: {},
  loading: false,
  error: "",
};

const tipoGestionContacto = (state = initialState, action) => {
  switch (action.type) {

    case TIPO_GESTION_CONTACTO_LIST:
      state = {
        ...state,
        loading: true,
      };
      return state;

      case TIPO_GESTION_CONTACTO_LIST_CHANGE:
        state = {
          ...state,
          loading: true,
        };
        return state;
    case TIPO_GESTION_CONTACTO_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        tipoGestionContacto: action.payload,
        tipoGestionContactoAdded: {},
      };
      return state;
    case TIPO_GESTION_CONTACTO_LIST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      return state;

    case TIPO_GESTION_CONTACTO_LISTA:
      state = {
        ...state,
        loading: true,
      };
      return state;

    case TIPO_GESTION_CONTACTO_LISTA_SUCCESS:
      state = {
        ...state,
        loading: false,
        tipoGestionContacto: action.payload,
        tipoGestionContactoAdded: {},
      };
      return state;
    case TIPO_GESTION_CONTACTO_LISTA_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      return state;

    case TIPO_GESTION_CONTACTO_ADD:
      state = {
        ...state,
        loading: true,
      };
      return state;
    case TIPO_GESTION_CONTACTO_ADD_SUCCESS:
      state = {
        ...state,
        loading: false,
        tipoGestionContactoAdded: action.payload,
        error: "",
      };
      return state;
    case TIPO_GESTION_CONTACTO_ADD_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      return state;


    case TIPO_GESTION_CONTACTO_DELETE:
      state = {
        ...state,
        loading: true,
      };
      return state;
    case TIPO_GESTION_CONTACTO_DELETE_SUCCESS:
      state = {
        ...state,
        loading: false,
        tipoGestionContactoDeleted: action.payload,
        error: "",
      };
      return state;
    case TIPO_GESTION_CONTACTO_DELETE_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      return state;

    
    default:
      state = { ...state };
      break;
  }
    
  return state;
};

export default tipoGestionContacto;
